module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-scrollbar-size/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 1764
// module chunks = 0